import {Typography} from '@mui/material'
import {makeStyles} from '@mui/styles'
import {FC} from 'react'
import {useTranslate} from 'react-admin'

import {useUserDisplayName} from '../../hooks/useUserDisplayName'
import {ChatMessages} from '../../types/graphqlSchema'
import {customerUserMetadata} from '../../utils/users'

const ForwardedChatMessageBanner: FC<ForwardedChatMessageBannerProps> = ({
  forwardedChatMessage: {authorUser},
}) => (
  <div className={useStyles().root}>
    <Typography variant="caption">
      {useTranslate()('chat.chatMessageBubble.originalMessageFrom')}
    </Typography>
    <Typography variant="subtitle2">{useUserDisplayName()(authorUser)}</Typography>
    <Typography variant="caption">
      {authorUser.customerUser && customerUserMetadata(authorUser.customerUser)}
    </Typography>
  </div>
)

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.text.secondary,
    marginBottom: theme.remSpacing(1),
    marginTop: theme.remSpacing(0.5),
  },
}))

interface ForwardedChatMessageBannerProps {
  forwardedChatMessage: ChatMessages
}

export default ForwardedChatMessageBanner
